var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4453_66461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5833 17.4165H17.4166C17.7158 17.4144 18.0098 17.3391 18.2732 17.1973C18.5365 17.0554 18.7612 16.8513 18.9275 16.6027C19.0938 16.3541 19.1968 16.0686 19.2275 15.771C19.2581 15.4735 19.2155 15.1729 19.1033 14.8956L12.595 3.66648C12.4364 3.37993 12.204 3.14107 11.9219 2.97475C11.6398 2.80842 11.3183 2.7207 10.9908 2.7207C10.6633 2.7207 10.3418 2.80842 10.0597 2.97475C9.77759 3.14107 9.54518 3.37993 9.38664 3.66648L2.8783 14.8956C2.76825 15.1666 2.72461 15.4599 2.75103 15.7512C2.77744 16.0424 2.87315 16.3231 3.03015 16.5698C3.18716 16.8166 3.40091 17.0222 3.65355 17.1694C3.9062 17.3167 4.19042 17.4014 4.48247 17.4165",
    fill: "#F13C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5833 17.4165H17.4166C17.7158 17.4144 18.0098 17.3391 18.2732 17.1973C18.5365 17.0554 18.7612 16.8513 18.9275 16.6027C19.0938 16.3541 19.1968 16.0686 19.2275 15.771C19.2581 15.4735 19.2155 15.1729 19.1033 14.8956L12.595 3.66648C12.4364 3.37993 12.204 3.14107 11.9219 2.97475C11.6398 2.80842 11.3183 2.7207 10.9908 2.7207C10.6633 2.7207 10.3418 2.80842 10.0597 2.97475C9.77759 3.14107 9.54518 3.37993 9.38664 3.66648L2.8783 14.8956C2.76825 15.1666 2.72461 15.4599 2.75103 15.7512C2.77744 16.0424 2.87315 16.3231 3.03015 16.5698C3.18716 16.8166 3.40091 17.0222 3.65355 17.1694C3.9062 17.3167 4.19042 17.4014 4.48247 17.4165",
    stroke: "#F13C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.25V11.6548M11 13.75V13.7592",
    stroke: "#E5E7ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4453_66461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.98944ae5d90fd7a52b499b0ce5781157.svg";
export { ForwardRef as ReactComponent };